module.exports = __webpack_public_path__ + "img/fauteuil-11.c524290d.jpg";